export default __webpack_public_path__ + "static/media/purchaseActived.98222a1c.svg";